import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=ec86d4cc&scoped=true"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=ec86d4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec86d4cc",
  null
  
)

export default component.exports